import Vue from 'vue';
import Vuex, { ModuleTree, GetterTree, ActionTree, MutationTree } from 'vuex';
import * as main from '@/store/main/state';
import { version } from '@growmark/versioning-vue';

Vue.use(Vuex);

type State = typeof state;
const state = {
  version: `${version}`.replace('v','')
};

const actions: ActionTree<State, State> = { };
const getters: GetterTree<State, State> = { 
  site: (state: State) => `v${state.version}`
};
const mutations: MutationTree<State> = { };
const modules: ModuleTree<State> = {
  [main.NAMESPACE]: main.module,
};

/** Promise to handle async plugins */
const vuex = new Vuex.Store({ 
  strict: true,
  state, 
  getters,
  mutations, 
  actions,
  modules,
});

export default vuex;